module.exports = __webpack_public_path__ + "static/img/packBack3.9d9269a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packBack3.jpg
// module id = AsJK
// module chunks = 0